<template>

  <div class="inner-box">
    <div class="table-area" style="margin-top: 0px;">
      <div class ="table-a">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col>
              <el-col :span="6">
                <el-form-item>
                <el-date-picker type="date" placeholder="Pick a date" v-model="form.startDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-input type="number" v-model="form.repairFee1"></el-input>
                  <el-input v-model="form.catId" v-show="false"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-input type="number" v-model="form.repairFee2"></el-input>
                  <el-input v-model="form.repairFeeId" v-show="false"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <div style="display: flex; width: 100%">
                    <el-input v-model="form.makerStr" readonly></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="openModel"></el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
import MakerModal from '@/components/InfoManage/ObstacleInfo/MakerModal.vue';


export default {
  name: "obstacleInfo",
  props: ['catDetail'],
  components: {MakerModal},
  data() {
    return {
      form: {
        catId:"",
        catIdx:"",
        catKey:"",
        catLvl:"",
        catNm:"",
        catPath:"",
        catValue1:"",
        catValue2:"",
        catValue3:"",
        catValue4:"",
        catValue5:"",
        companyId:"",
        createDt: this.$moment(new Date()).format('YYYY-MM-DD'),
        creatorId:"",
        creatorNm:"",
        deleteYn:"",
        description:"",
        endDt:"",
        keyPath:"",
        parentId:"",
        repairCatId:"",
        repairFee1:"",
        repairFee2:"",
        repairFee3:0,
        repairFee4:0,
        repairFee5:0,
        repairFee6:0,
        repairFee7:0,
        repairFee8:0,
        repairFee9:0,
        repairFee10:0,
        repairFeeId:"",
        makers:[],
        makerStr:"",
        sortPath:"",
        startDt:this.$moment(new Date()).format('YYYY-MM-DD'),
        topKey:"RepairCat",
        updateDt:"",
        updatorId:"",
        updatorNm:"",
        useYn: "Y",
      },
      // eslint-disable-next-line vue/no-dupe-keys
    };
  },
  methods: {
    getNumberFormat(val) {
      if(val){

        if(typeof val === "string"){
          val = val.replace(/[^0-9]/g, "")
        }

        return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    setCatInfo() {
      this.form.repairCatId = this.catDetail.catId;

      // Object.assign(this.form, this.catDetail, this.form.makerStr);
      // this.form = this.catDetail;
    },
    openModel() {
      let vm = this;
      this.$modal.open({
        width: 400,
        component: MakerModal,
        parent: this,
        props: {
          data: {
          }
        },
        events: {
          close(param) {
            // vm.setCatInfo();
            vm.form.makerStr = "";
            vm.form.makers = [];
            for(var i=0; param.length > i ; i++){
              vm.form.makers.push({
                repairFeeId : vm.form.repairFeeId,
                makerId : param[i].makerId,
                makerNm : param[i].makerNm,
              });
            }

            vm.form.makers.forEach((x,i)=>{
              if(i == 0){
                vm.form.makerStr = x.makerNm;
              }else{
                vm.form.makerStr += ',' + x.makerNm;
              }
            })
            vm.$forceUpdate();
          },
        }
      });
    },
  },
  watch: {
    catDetail() {
      this.setCatInfo();
    }
  }
}

</script>

<style scoped>

</style>